// Utils
import { getEnvironmentApiUrl } from "../../services/General";
import { FiltersPatientCases } from "../../reducers/patient-cases-reducer";

// Hooks
import useHttp from "../../hooks/useHttp";
import { useEffect, useMemo, useState } from "react";
import useDebounce from "../../hooks/useDebouncer";

// Models
import { CaseHistory } from "../../interfaces/Patient";
interface HistoricQueryCase {
    data: CaseHistory[]
    total: number
    total_unfiltered: number
}
type CaseQuerySortAttributes = 'hospital_case' | 'patient_full_name' | 'bed_id' | 'start_date' | 'end_date' | 'surgery_started_date' | 'surgery_ended_date';

// Constants
const COLUMNS_KEYS_ATTRIBUTES: { [id: number]: CaseQuerySortAttributes } = {
    0: 'patient_full_name',
    1: 'hospital_case',
    4: 'start_date',
    5: 'end_date',
}
const CASES_PER_PAGE = 20;

const useCaseHistoricQuery = (
    filtersCases: FiltersPatientCases,
    currentPage: number,
    columnIndex: number,
    sortAsc: boolean
) => {

    const { isLoading, error, sendRequest } = useHttp<HistoricQueryCase>();

    const [historicCases, setHistoricCases] = useState<CaseHistory[]>([]);
    const [totalCases, setTotalCases] = useState<number>();
    const [totalCasesUnfiltered, setTotalCasesUnfiltered] = useState<number>();

    const { searchText, entryDateFrom, exitDateTo, environmentID } = filtersCases;

    const debouncedText = useDebounce(searchText, 500);
    
    const sortAttr = COLUMNS_KEYS_ATTRIBUTES[columnIndex];

    const filters = useMemo(() => {
        return {
            search_text: debouncedText ?? undefined,
            entry_date_from: entryDateFrom?.toISOString(),
            exit_date_to: exitDateTo ?? undefined,
            profile_id: environmentID ?? undefined,
            is_home: true,
        }
    }, [debouncedText, entryDateFrom, exitDateTo, environmentID])

    useEffect(() => {
        sendRequest({
            url: getEnvironmentApiUrl() + 'case/historic_query',
            method: 'POST',
            body: {
                includeTotalUnfiltered: true,
                nestOptions: { diagnosis: true },
                filters: filters,
                limit: CASES_PER_PAGE,
                page: currentPage,
                sortAsc: sortAsc,
                sortAttr: sortAttr ?? 'start_date',

            }
        }, (data) => {
            setHistoricCases(data.data);
            setTotalCases(data.total);
            setTotalCasesUnfiltered(data.total_unfiltered);
        })
    }, [filters, currentPage, sendRequest, sortAsc, sortAttr]);


    const numPages = totalCases === undefined ? 0 : Math.ceil(totalCases / CASES_PER_PAGE);


    return {
        totalCases,
        totalCasesUnfiltered,
        numPages,
        historicCases,
        isLoading,
        error,
    }
}

export default useCaseHistoricQuery;